(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-reviews-mobile-polish"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dates = ['Mar 18, 2026', 'Apr 06, 2026', 'May 22, 2026', 'Jun 14, 2026'];

    const setupHeader = (headerSelector, navSelector, buttonClass) => {
      document.querySelectorAll(headerSelector).forEach((header) => {
        if (header.querySelector(`.${buttonClass}`)) return;

        const nav = header.querySelector(navSelector);
        if (!nav) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = buttonClass;
        button.setAttribute('aria-label', 'Open menu');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"></path><path d="M4 12h16"></path><path d="M4 17h16"></path></svg>';

        button.addEventListener('click', () => {
          const isOpen = header.classList.toggle('is-mobile-menu-open');
          button.setAttribute('aria-expanded', String(isOpen));
          button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        });

        header.appendChild(button);
      });
    };

    const addReviewDates = () => {
      document.querySelectorAll('.tgx__person').forEach((person, index) => {
        if (person.querySelector('.tgx__date')) return;

        const date = document.createElement('time');
        date.className = 'tgx__date';
        date.dateTime = dates[index] || dates[0];
        date.textContent = dates[index] || dates[0];
        person.appendChild(date);
      });
    };

    const applyPatch = () => {
      setupHeader('.ga-header', '.ga-nav', 'ga-mobile-menu-toggle');
      setupHeader('.tgx-header', '.tgx-nav', 'tgx-mobile-menu-toggle');
      addReviewDates();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPatch);
    } else {
      applyPatch();
    }

    document.addEventListener('shopify:section:load', applyPatch);
    document.addEventListener('click', (event) => {
      document.querySelectorAll('.ga-header.is-mobile-menu-open, .tgx-header.is-mobile-menu-open').forEach((header) => {
        if (header.contains(event.target)) return;
        header.classList.remove('is-mobile-menu-open');
        const button = header.querySelector('.ga-mobile-menu-toggle, .tgx-mobile-menu-toggle');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["china-sourcing-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scroll-quote]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const target = document.querySelector('#quote-form');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desktop-form-platform-fix"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const restorePlatformColor = () => {
      document.querySelectorAll('.gs-platforms .gs-platform img').forEach((image) => {
        image.style.filter = 'grayscale(0) saturate(1.22) contrast(1.03)';
        image.style.opacity = '1';
      });
    };

    restorePlatformColor();
    document.addEventListener('DOMContentLoaded', restorePlatformColor);
    document.addEventListener('shopify:section:load', restorePlatformColor);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-form-visual-patch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const addImagePickers = () => {
      const form = document.querySelector('.gs-form');
      if (!form || form.dataset.imagePickersReady === 'true') return;

      const labels = Array.from(form.querySelectorAll('label'));
      const targets = [
        { label: labels[0], key: 'Product image filename', button: 'Upload product image' },
        { label: labels[1], key: 'Variant image filename', button: 'Upload variant / style image' }
      ];

      targets.forEach((target, index) => {
        if (!target.label || target.label.querySelector('.gs-image-picker')) return;

        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = `contact[${target.key}]`;
        form.insertBefore(hidden, target.label.nextSibling);

        const picker = document.createElement('span');
        picker.className = 'gs-image-picker';

        const inputId = `gs-image-picker-${index + 1}`;
        const input = document.createElement('input');
        input.id = inputId;
        input.className = 'gs-image-picker__input';
        input.type = 'file';
        input.accept = 'image/*';

        const button = document.createElement('label');
        button.className = 'gs-image-picker__button';
        button.setAttribute('for', inputId);
        button.setAttribute('aria-label', target.button);
        button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><circle cx="8.5" cy="10" r="1.5"></circle><path d="m21 15-4.5-4.5L9 18"></path></svg>';

        const meta = document.createElement('span');
        meta.className = 'gs-image-picker__meta';

        const preview = document.createElement('img');
        preview.className = 'gs-image-picker__preview';
        preview.alt = '';

        const name = document.createElement('span');
        name.textContent = 'No image selected';

        meta.append(preview, name);
        picker.append(button, input, meta);
        target.label.appendChild(picker);

        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          if (!file) {
            hidden.value = '';
            meta.classList.remove('is-visible');
            name.textContent = 'No image selected';
            preview.removeAttribute('src');
            return;
          }

          hidden.value = file.name;
          name.textContent = file.name;
          preview.src = URL.createObjectURL(file);
          meta.classList.add('is-visible');
        });
      });

      form.dataset.imagePickersReady = 'true';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addImagePickers, { once: true });
    } else {
      addImagePickers();
    }

    window.addEventListener('load', addImagePickers, { once: true });
    document.addEventListener('shopify:section:load', addImagePickers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-platforms-patch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewsHref = '/pages/testimonials';

    const addReviewsLink = () => {
      document.querySelectorAll('.gs-nav, .ga-nav').forEach((nav) => {
        if (nav.querySelector(`a[href="${reviewsHref}"], a[href$="${reviewsHref}"]`)) return;
        const link = document.createElement('a');
        link.href = reviewsHref;
        link.textContent = 'Reviews';
        nav.appendChild(link);
      });

      document.querySelectorAll('.gs-footer nav, .ga-footer nav').forEach((nav) => {
        if (nav.querySelector(`a[href="${reviewsHref}"], a[href$="${reviewsHref}"]`)) return;
        const link = document.createElement('a');
        link.href = reviewsHref;
        link.textContent = 'Reviews';
        nav.appendChild(link);
      });
    };

    const replacePaymentBlock = () => {
      const block = document.querySelector('.gs-payments');
      if (!block || block.dataset.platformsReady === 'true') return;

      block.dataset.platformsReady = 'true';
      block.classList.add('gs-platforms');
      block.setAttribute('aria-labelledby', 'platforms-title');
      block.innerHTML = `
        <p class="gs-eyebrow">Supported sourcing platforms</p>
        <div aria-label="Supported Chinese sourcing platforms">
          <span class="gs-platform" data-label="TaoBao"><img src="https://cdn.shopify.com/s/files/1/0649/4840/4329/files/platform-taobao.jpg?v=1783480728" alt="TaoBao app icon" width="148" height="148" loading="lazy" style="filter:grayscale(0) saturate(1.18) contrast(1.03) !important;opacity:1 !important;"></span>
          <span class="gs-platform" data-label="PinDuoDuo"><img src="https://cdn.shopify.com/s/files/1/0649/4840/4329/files/platform-pinduoduo.jpg?v=1783480838" alt="PinDuoDuo app icon" width="148" height="148" loading="lazy" style="filter:grayscale(0) saturate(1.18) contrast(1.03) !important;opacity:1 !important;"></span>
          <span class="gs-platform" data-label="1688"><img src="https://cdn.shopify.com/s/files/1/0649/4840/4329/files/platform-1688.jpg?v=1783480767" alt="1688 app icon" width="148" height="148" loading="lazy" style="filter:grayscale(0) saturate(1.18) contrast(1.03) !important;opacity:1 !important;"></span>
          <span class="gs-platform" data-label="Xianyu"><img src="https://cdn.shopify.com/s/files/1/0649/4840/4329/files/platform-xianyu.jpg?v=1783480880" alt="Xianyu app icon" width="148" height="148" loading="lazy" style="filter:grayscale(0) saturate(1.18) contrast(1.03) !important;opacity:1 !important;"></span>
          <span class="gs-platform" data-label="WeiDian"><img src="https://cdn.shopify.com/s/files/1/0649/4840/4329/files/platform-weidian.jpg?v=1783480799" alt="WeiDian app icon" width="148" height="148" loading="lazy" style="filter:grayscale(0) saturate(1.18) contrast(1.03) !important;opacity:1 !important;"></span>
        </div>
      `;
    };

    const updateHeroIntro = () => {
      const subtitle = document.querySelector('.gs-subtitle');
      if (subtitle) {
        subtitle.textContent = 'The sourcing agency built exclusively for small and medium-sized sellers. Zero MOQ. Fast Global Shipping. 100% Quality Inspected. We help you source from China with zero risk.';
      }

      const trusted = document.querySelector('.gs-trusted');
      if (!trusted || trusted.dataset.iconsReady === 'true') return;

      trusted.dataset.iconsReady = 'true';
      trusted.classList.add('gs-trusted--icons');
      trusted.innerHTML = `
        <span class="gs-trusted__label">Trusted Partners</span>
        <span class="gs-trusted__brand gs-trusted__brand--stripe" aria-label="Stripe"><img src="https://cdn.simpleicons.org/stripe/635BFF" alt="Stripe logo" loading="lazy"></span>
        <span class="gs-trusted__brand gs-trusted__brand--wise" aria-label="Wise"><img src="https://cdn.simpleicons.org/wise/00B9FF" alt="Wise logo" loading="lazy"></span>
        <span class="gs-trusted__brand gs-trusted__brand--paypal" aria-label="PayPal"><img src="https://cdn.simpleicons.org/paypal/003087" alt="PayPal app logo" loading="lazy"></span>
        <span class="gs-trusted__brand gs-trusted__brand--alipay" aria-label="Alipay"><img src="https://cdn.simpleicons.org/alipay/1677FF" alt="Alipay app logo" loading="lazy"></span>
        <span class="gs-trusted__brand gs-trusted__brand--visa" aria-label="Visa"><img src="https://cdn.simpleicons.org/visa/1434CB" alt="Visa logo" loading="lazy"></span>
        <span class="gs-trusted__brand gs-trusted__brand--mastercard" aria-label="Mastercard"><img src="https://cdn.simpleicons.org/mastercard/EB001B" alt="Mastercard logo" loading="lazy"></span>
      `;
    };

    const setupMobileHeader = () => {
      document.querySelectorAll('.gs-header').forEach((header) => {
        if (header.querySelector('.gs-mobile-menu-toggle')) return;

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'gs-mobile-menu-toggle';
        toggle.setAttribute('aria-label', 'Open menu');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/></svg>';

        toggle.addEventListener('click', () => {
          const isOpen = header.classList.toggle('is-mobile-menu-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
          toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        });

        header.appendChild(toggle);
      });

      if (!window.goshopMobileMenuOutsideClickReady) {
        window.goshopMobileMenuOutsideClickReady = true;
        document.addEventListener('click', (event) => {
          document.querySelectorAll('.gs-header.is-mobile-menu-open').forEach((header) => {
            if (header.contains(event.target)) return;
            const toggle = header.querySelector('.gs-mobile-menu-toggle');
            header.classList.remove('is-mobile-menu-open');
            if (toggle) {
              toggle.setAttribute('aria-expanded', 'false');
              toggle.setAttribute('aria-label', 'Open menu');
            }
          });
        });
      }
    };

    const replaceFeatureCards = () => {
      const features = document.querySelector('.gs-features');
      if (!features || features.dataset.updatedFeatures === 'true') return;

      features.dataset.updatedFeatures = 'true';
      features.innerHTML = `
        <article><div class="gs-feature-icon"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/></svg></div><h3>Dedicated 1-on-1 Support</h3><p>Get paired with a real human sourcing expert who provides proactive, real-time updates on your order progress.</p></article>
        <article><div class="gs-feature-icon"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg></div><h3>Full Transit Insurance</h3><p>Parcels are fully covered against loss for any reason during processing and freight&mdash;right up until the final-mile carrier scans them.</p></article>
        <article><div class="gs-feature-icon"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg></div><h3>Smart Link Comparison</h3><p>Send us multiple product links. We compare quality, negotiate costs, and secure the absolute best value for your business.</p></article>
        <article><div class="gs-feature-icon"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/></svg></div><h3>Pre-Shipping Full Refunds</h3><p>Change your mind? Enjoy a 100% no-questions-asked refund guarantee on any order before it leaves our warehouse.</p></article>
      `;
    };

    const applyPatch = () => {
      addReviewsLink();
      updateHeroIntro();
      setupMobileHeader();
      replacePaymentBlock();
      replaceFeatureCards();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPatch);
    } else {
      applyPatch();
    }

    document.addEventListener('shopify:section:load', applyPatch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-icons-only-patch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanTrustedPartners = () => {
      document.querySelectorAll('.gs-trusted__brand--worldfirst, .gs-trusted__item--worldfirst').forEach((item) => item.remove());
      document.querySelectorAll('.gs-trusted__brand > span').forEach((label) => label.remove());
    };

    cleanTrustedPartners();
    document.addEventListener('shopify:section:load', cleanTrustedPartners);
    window.setTimeout(cleanTrustedPartners, 200);
    window.setTimeout(cleanTrustedPartners, 800);
  })();

  } catch(e) { console.error(e); }
})();
})();
